import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './FinancialAccountFormSection.module.scss'
import classnames from 'classnames'
import {
  SCHWAB_ONE_PERSONAL,
  SCHWAB_ONE_TRUST,
  SCHWAB_IRA,
  SCHWAB_CHARITABLE,
} from 'utils/financialAccountTypes'
import PersonalAccountFormSection from './PersonalAccountFormSection'
import TrustAccountFormSection from './TrustAccountFormSection'
import IRAAccountFormSection from './IRAAccountFormSection'
import CharitableAccountFormSection from './CharitableAccountFormSection'

class FinancialAccountFormSection extends Component {

  constructor (props) {
    super(props)
    this.handleSubSectionVisibility = this.handleSubSectionVisibility.bind(this)
  }

  handleSubSectionVisibility () {
    const {
      collapsed,
      setCollapsed,
      financialAccountId,
    } = this.props
    setCollapsed(financialAccountId, !collapsed)
  }

  render () {
    const {
      name,
      financialAccountId,
      hasJointOwner,
      financialAccountType,
      collapsed,
      sectionsOverview,
      financialAccounts,
    } = this.props

    const arrowStyles = classnames(styles.arrow,
      !collapsed ? styles.arrowUp : styles.arrowDown)

    const financialAccount = financialAccounts.find(({ id }) => id === financialAccountId)

    return (
      <li className={styles.FinancialAccountFormSection}>
        <div className={styles.accountName} onClick={this.handleSubSectionVisibility}>
          <span>{name}</span>
          <div className={arrowStyles} />
        </div>
        <ul className={collapsed ? styles.collapsed : styles.expanded}>
          { financialAccountType === SCHWAB_ONE_PERSONAL.ACCOUNT_TYPE_ROUTE && (
            <PersonalAccountFormSection
              financialAccountId={financialAccountId}
              financialAccountType={financialAccountType}
              financialAccount={financialAccount}
              hasJointOwner={hasJointOwner}
              sectionsOverview={sectionsOverview} />
          ) }
          { financialAccountType === SCHWAB_ONE_TRUST.ACCOUNT_TYPE_ROUTE && (
            <TrustAccountFormSection
              financialAccountId={financialAccountId}
              financialAccountType={financialAccountType}
              sectionsOverview={sectionsOverview} />
          ) }
          { financialAccountType === SCHWAB_IRA.ACCOUNT_TYPE_ROUTE && (
            <IRAAccountFormSection
              financialAccountId={financialAccountId}
              financialAccountType={financialAccountType}
              sectionsOverview={sectionsOverview}
              financialAccounts={financialAccounts} />
          ) }
          { financialAccountType === SCHWAB_CHARITABLE.ACCOUNT_TYPE_ROUTE && (
            <CharitableAccountFormSection
              financialAccountId={financialAccountId}
              financialAccountType={financialAccountType}
              sectionsOverview={sectionsOverview}
              financialAccounts={financialAccounts} />
          ) }
        </ul>
      </li>
    )
  }

}

FinancialAccountFormSection.propTypes = {
  name: PropTypes.string.isRequired,
  financialAccountId: PropTypes.string.isRequired,
  hasJointOwner: PropTypes.bool,
  financialAccountType: PropTypes.string.isRequired,
  collapsed: PropTypes.bool,
  setCollapsed: PropTypes.func.isRequired,
  sectionsOverview: PropTypes.object,
  financialAccounts: PropTypes.array,
}

FinancialAccountFormSection.defaultProps = {
  hasJointOwner: false,
  collapsed: true,
  sectionsOverview: {},
  financialAccounts: [],
}

export default FinancialAccountFormSection



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMSidebar/FinancialAccountFormGroup/FinancialAccountFormSection/FinancialAccountFormSection.jsx